import information from './modules/information'
import rate from './modules/rate'

export default {
  information,
  rate
}
